import SideMenu from "../../features/sideMenu/SideMenu";
import WorkCenter from "./WorkCenter";
import { itemsProjects } from "../../constants/projects";
import "./WorkCenterPage.responsive.css";

const WorkCenterPage = ({
  API_URL,
  companies,
  perfiles,
  clients,
  permisionarios,
  projects,
  states,
}) => {
  return (
    <div
      className="wcPage-container"
      style={{ display: "flex", width: "100%" }}
    >
      <div className="wcPage-sidebar">
        <SideMenu items={itemsProjects} />
      </div>
      <div
        className="wcPage-main"
        style={{ flex: 1, padding: "10px", width: "100%" }}
      >
        <WorkCenter
          API_URL={API_URL}
          companies={companies}
          perfiles={perfiles}
          page={true}
          clients={clients}
          permisionarios={permisionarios}
          projects={projects}
          states={states}
        />
      </div>
    </div>
  );
};

export default WorkCenterPage;
